module.exports = __webpack_public_path__ + "img/telegram.8443008f.svg";